<template>
  <div v-scroll class="Header">
    <div v-if="$store.getters.appInfo" class="header-main">
      <div class="hm-first">
        <img :src="$store.getters.appInfo.logo" class="hmf-avatar" />
        <div class="hmf-name">
          {{ $store.getters.appInfo.ff_name
          }}<el-tooltip
            class="item"
            effect="dark"
            content="模拟测试"
            placement="top-start"
          >
            <i class="su-icon-test" @click="handleSimulation" />
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="发起流程"
            placement="top-start"
          >
            <i class="su-icon-daifasong" @click="handleOpenWrite" />
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="下载应用json"
            placement="top-start"
          >
            <i
              v-if="showDownloadIcon"
              class="el-icon-download"
              @click="handleDownload"
            />
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="应用设置"
            placement="top-start"
          >
            <i class="el-icon-setting" @click="manageVisible" />
          </el-tooltip>
        </div>
      </div>
      <div class="hm-second">
        <span class="gray84">描述：</span>
        <span class="black31">{{ $store.getters.appInfo.ff_describe }}</span>
      </div>
      <div class="hm-third">
        <div class="mr80">
          <span class="gray84">所属应用组：</span>
          <span class="black31">{{
            $store.getters.appInfo.ff_group_name
          }}</span>
        </div>
        <div class="mr80">
          <span class="gray84">最新版本：</span>
          <span class="black31">{{ $store.getters.appInfo.version }}</span>
        </div>
        <div class="mr80">
          <span class="gray84">创建人：</span>
          <span class="black31">{{ $store.getters.appInfo.creatorName }}</span>
        </div>
        <div class="mr80">
          <span class="gray84">创建时间：</span>
          <span class="black31">{{
            $store.getters.appInfo.create_time | format_time
          }}</span>
        </div>
      </div>
    </div>
    <div v-if="tab.length" class="header__tab">
      <div style="display: flex">
        <div
          v-for="(item, index) in tab"
          :key="index"
          :class="{ 'ht-item': true, 'ht-item-active': item === currentTab }"
          @click="toggleTab(item, index)"
        >
          {{ item }}
        </div>
      </div>
      <div>
        <slot name="btn" />
      </div>
    </div>
    <div
      v-if="tab.length && isSticky"
      :style="{ width: tabFixedWidth + 'px' }"
      class="header__tab header__tab-fixed"
    >
      <div style="display: flex">
        <div
          v-for="(item, index) in tab"
          :key="index"
          :class="{ 'ht-item': true, 'ht-item-active': item === currentTab }"
          @click="toggleTab(item, index)"
        >
          {{ item }}
        </div>
      </div>
      <div>
        <slot name="btn" />
      </div>
    </div>
    <manage ref="manage" />
  </div>
</template>

<script>
import service, { designFormUrl, baseURL } from "@/utils/service";
import Manage from "../manage/manage";
export default {
  components: { Manage },
  directives: {
    scroll: {
      bind: function (el, binding, vnode) {
        window.addEventListener("scroll", vnode.context.scrollLoad);
      },
      // 路由转跳到其他页面时，会调用unbind，解绑滚动加载事件。
      unbind: function (el, binding, vnode) {
        window.removeEventListener("scroll", vnode.context.scrollLoad);
      },
    },
  },
  filters: {
    format_time(sec) {
      const ft = new Date(sec);

      const y = ft.getFullYear();
      const m = ft.getMonth() + 1;
      const d = ft.getDate();
      const h = ft.getHours();
      const ms = ft.getMinutes();
      const s = ft.getSeconds();

      const formatNum = (num) => {
        if (num < 10) {
          return "0" + num;
        }
        return num;
      };
      return (
        y +
        "-" +
        formatNum(m) +
        "-" +
        formatNum(d) +
        " " +
        formatNum(h) +
        ":" +
        formatNum(ms) +
        ":" +
        formatNum(s)
      );
    },
  },
  props: {
    tab: {
      type: Array,
      default: function () {
        return [];
      },
    },
    index: {
      type: Number,
      default: function () {
        return 0;
      },
    },
  },
  data() {
    return {
      tabFixedWidth: "",
      currentTab: this.tab[this.index],
      isSticky: false,
      showDownloadIcon: false,
    };
  },
  computed: {
    closedUrl() {
      return this.$serverConfig.CLOSEDURL;
    },
  },
  watch: {
    index(newVal, oldVal) {
      this.toggleTab(this.tab[newVal], newVal);
    },
  },
  created() {
    this.checkAppStatus();
  },
  methods: {
    manageVisible() {
      this.$refs["manage"].show();
    },
    scrollLoad() {
      // 固定顶部距离
      // 获取距离顶部实时距离
      const headerMainRect = document
        .querySelector(".header-main")
        .getBoundingClientRect();
      const navbarRect = document
        .querySelector(".navbar")
        .getBoundingClientRect();
      // 用来获取固定header-tab的宽度
      this.tabFixedWidth = headerMainRect.width;
      if (headerMainRect.height + headerMainRect.top <= navbarRect.height) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },
    toggleTab(item, index) {
      this.currentTab = item;
      this.$emit("toggletab", item, index);
    },
    handleSimulation() {
      window.open(
        `${designFormUrl}/simulation?yyid=${
          this.$route.query.yyid
        }&from=adminplatform&token=${localStorage.getItem("Admin-Token")}`,
        "_blank"
      );
    },
    handleOpenWrite() {
      if (this.closedUrl) {
        window.open(
          `${designFormUrl}/write?yyid=${this.$route.query.yyid}&closedUrl=${
            this.closedUrl
          }&token=${localStorage.getItem("Admin-Token")}`,
          "_blank"
        );
      } else {
        window.open(
          `${designFormUrl}/write?yyid=${
            this.$route.query.yyid
          }&token=${localStorage.getItem("Admin-Token")}`,
          "_blank"
        );
      }
    },
    handleDownload() {
      window.open(
        baseURL +
          `/v1/exportJson/downJson?yyid=${
            this.$route.query.yyid
          }&token=${localStorage.getItem("Admin-Token")}`,
        "_blank"
      );
    },
    checkAppStatus() {
      service
        .get("/v1/exportJson/queryPublishStatus", {
          params: { yyid: this.$route.query.yyid },
        })
        .then((res) => {
          if (!res.flag) {
            this.$message.error(res.msg);
          }
          if (res.data === "1") {
            this.showDownloadIcon = true;
          } else {
            this.showDownloadIcon = false;
          }
        })
        .catch((error) => {
          this.$message(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.header-main {
  padding: 15px 20px 20px;
  .hm-first {
    display: flex;
    align-items: center;
    .hmf-avatar {
      width: 40px;
      height: 40px;
      margin-right: 12px;
    }
    .hmf-name {
      line-height: 28px;
      font-size: 20px;
      font-weight: 400;
      color: #273846;
    }
  }
  .gray84 {
    color: #84909a;
  }
  .black31 {
    color: #314250;
  }
  .mr80 {
    margin-right: 80px;
  }
  .hm-second {
    margin-top: 2px;
    margin-left: 52px;
    font-size: 12px;
    line-height: 20px;
  }
  .hm-third {
    margin-top: 10px;
    margin-left: 52px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 12px;
    line-height: 20px;
  }
}
.header__tab {
  padding: 0 20px;
  border-top: 1px solid #e1e4e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #626f79;
}
.header__tab-fixed {
  position: fixed;
  top: 50px;
  z-index: 100;
  background: #fff;
}
.ht-item {
  cursor: pointer;
  margin-right: 80px;
  height: 50px;
  display: flex;
  font-size: 14px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid transparent;
  &:hover {
    color: #3394e1;
  }
}
.ht-item-active {
  border-bottom: 1px solid #3394e1;
  color: #3394e1;
}
</style>
<style lang="scss" scoped>
.su-icon-test,
.el-icon-download,
.el-icon-setting,
.su-icon-daifasong {
  margin-left: 5px;
  cursor: pointer;
  color: #3394e1;
}
</style>
